class QueueMessage {
    public id: string;
    public message: string;
}

export class Messager {
    public show: boolean = false;
    public text: string = '';
    public color: string = '';
    public timeout: number = -1;
    public vertical: boolean = true;
    public mobileAbsolute: boolean = false;
    public desktopAbsolute: boolean = true;
    public contentClass: string = '';
    private queue: QueueMessage[] = [];
    private millisecondsPerWord: number = 300;
    private currentId: string = '';

    public success(text: string) {
        this.color = 'success';
        this.addToQueue(text);
    }

    public error(text: string) {
        this.color = '#e80808';
        this.contentClass = 'creative-snackbar-error';
        this.addToQueue(text);
    }

    public info(text: string) {
        this.color = '#f0f0f0';
        this.contentClass = 'creative-snackbar-info';
        this.addToQueue(text);
    }

    public close() {
        this.remove(this.currentId);
        if (this.queue.length) {
            this.showFirstTextInQueue();
        } else {
            this.show = false;
        }
    }

    private addToQueue(text: string) {
        if (!this.find(text)) {
            this.queue.push({ message: text, id: this.getId() });
        }
        if (this.queue.length === 1) {
            this.showFirstTextInQueue();
        }
    }

    private showFirstTextInQueue() {
        this.text = this.queue[0].message;
        this.currentId = this.queue[0].id;
        this.setTimeout();
        this.show = true;

        const myId = this.currentId;
        setTimeout(() => {
            this.remove(myId);
            if (this.queue.length) {
                this.showFirstTextInQueue();
            }
        }, this.timeout + 500);
    }

    private setTimeout() {
        const words = this.text.split(' ').length;
        this.timeout = words * this.millisecondsPerWord;
    }

    private find(message: string): boolean {
        return this.queue.filter((x) => x.message == message).length > 0;
    }

    private getId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    private remove(id: string) {
        this.queue = this.queue.filter((x) => x.id != id);
    }
}

export const messager = new Messager();
